import { render, staticRenderFns } from "./AccountModified.vue?vue&type=template&id=3abf5c40&scoped=true&"
import script from "./AccountModified.vue?vue&type=script&lang=js&"
export * from "./AccountModified.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abf5c40",
  null
  
)

export default component.exports